const screenMinWidths = {
    mobile: 320,
    desktop: 1440,
} as const

const useScreenWidth = () => {
    const width = window.innerWidth
    const isMobile = width < screenMinWidths.desktop
    return {isMobile}
}

export default useScreenWidth
